import React from 'react';

export default function HolidayList({ t, monthlyHolidays, getHolidayName, isLoading, error }) {
  return (
    <div className="card">
      <h3 className="section-title">{t.keyHolidaysTitle}</h3>
      {isLoading ? (
        <p className="muted-text small-text">{t.loading}</p>
      ) : error ? (
        <p className="muted-text small-text">{error}</p>
      ) : monthlyHolidays.length ? (
        <ul className="holiday-list">
          {monthlyHolidays.map((holiday) => (
            <li key={`${holiday.code || holiday._id}-${holiday.solarDisplay}-${holiday.lunarDisplay}`} className="holiday-item">
              <p className="holiday-name">{getHolidayName(holiday)}</p>
              <p className="holiday-meta">
                {holiday.type === 'solar'
                  ? `${t.solar}: ${holiday.solarDisplay}`
                  : `${t.lunar}: ${holiday.lunarDisplay}`}
              </p>
            </li>
          ))}
        </ul>
      ) : (
        <p className="muted-text small-text">{t.noHolidays}</p>
      )}
    </div>
  );
}
